var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImgFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 150,
    viewBox: "0 0 250 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(-75 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 250,
    height: 150,
    transform: "translate(75 169)",
    fill: "rgba(190,18,22,0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "No_Poster_Found",
    "data-name": "No Poster Found",
    transform: "translate(200 251)",
    fill: "#979292",
    stroke: "#c9aeae",
    strokeWidth: 1,
    fontSize: 14,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.084em",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -61.149,
    y: 0
  }, "No Poster Found")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgFound);
export default __webpack_public_path__ + "static/media/no-img-found.b5b53d0d6a8a5839e9c41bc90c41fc16.svg";
export { ForwardRef as ReactComponent };